export default __webpack_public_path__ + "static/media/breakfast_7.7475986c.jpg";